let archive = document.querySelector(".archive");

//Desktop
let sliderWrapDesk = document.querySelector(".slide-block-desktop");
let allSlidesDesk = sliderWrapDesk.querySelectorAll(".slide");
let slideLimitDesk = allSlidesDesk.length - 1;
let allNamesDesk = sliderWrapDesk.querySelectorAll(".controls .name");
let nameWrapDesk = document.querySelector(".ani-page .navigation-desktop .name");

window.addEventListener("load", function () {

  document.querySelector(".lookbook-pg main").classList.add("loaded");

  let season = document.querySelector(".ani-page").dataset.season;
  let seasonDesk = document.querySelector(".navigation-desktop .season");
  let seasonMob = document.querySelector(".navigation-mobile .season");

  let lookbookWrap = document.querySelector('.ani-page');
  let mensCheck = false;

  if(lookbookWrap.dataset.season == 'Mens'){
    mensCheck = true;
  }

  seasonDesk.innerHTML = season;
  seasonMob.innerHTML = season;

  nameWrapDesk.innerHTML = allNamesDesk[0].innerHTML;

  allSlidesDesk.forEach(function (item, i) {
    if (i == 0) {
    } else {
      item.classList.add("hide");
    }

    let leftSide = item.querySelector(".left");
    let rightSide = item.querySelector(".right");

    leftSide.addEventListener("click", function () {
      //console.log("Left turn " + i);
      if (i == 0) {
        //let prev = 0;
      } else {
        let prev = i - 1;
        turnSlideDesk(prev);
        nameWrapDesk.innerHTML = allNamesDesk[prev].innerHTML;
      }
    });

    rightSide.addEventListener("click", function () {
      //console.log("Right turn " + i);
      if (i == slideLimitDesk) {
      } else {
        let next = i + 1;
        turnSlideDesk(next);
        nameWrapDesk.innerHTML = allNamesDesk[next].innerHTML;
      }
    });
  });

  let coverDefaultLinks = document.querySelectorAll(".navigation-desktop .name a");

  coverDefaultLinks.forEach(function (xtem, x) {
    let currentName = xtem.innerHTML;
    let preHandle = currentName.replace(/'/g, "");
    let theHandle = preHandle.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, "-");

    if (lookbookWrap.dataset.season == "Mens") {
      mensCheck = true;
    }

    if (mensCheck) {
      if (theHandle == "nautilus-cigarette-box" || theHandle == "the-harvey-bracelet" || theHandle == "roberto-chain" || theHandle == "sterling-silver-coquille-box" || theHandle == "nautilus-knife" || theHandle == "harvey-bracelet" || theHandle == "quartz-coquille-box") {
      } else {
        theHandle = theHandle + "-mens";
        //console.log(theHandle + "Firsto");
      }
    }
  });
});

/*



Mobile Lookbook



*/

let sliderWrapMob = document.querySelector(".slide-block-mobile");
let allSlidesMob = sliderWrapMob.querySelectorAll(".slide");
let slideLimitMob = allSlidesMob.length - 1;
console.log(slideLimitMob);
let allNamesMob = sliderWrapMob.querySelectorAll(".controls .name");
let nameWrapMob = document.querySelector(".ani-page .navigation-mobile .name");

window.addEventListener("load", function () {

  allSlidesMob.forEach(function (item, i) {
    if (i == 0) {
    } else {
      item.classList.add("hide");
    }

    let leftSide = item.querySelector(".left");
    let rightSide = item.querySelector(".right");

    leftSide.addEventListener("click", function (event) {
      event.preventDefault();
      //console.log("Left turn " + i);
      if (i == 0) {
        //let prev = 0;
      } else {
        let prev = i - 1;
        turnSlideMob(prev);
        nameWrapMob.innerHTML = allNamesMob[prev].innerHTML;
      }
    });

    rightSide.addEventListener("click", function (event) {
      event.preventDefault();
      //console.log("Right turn " + i);
      if (i == slideLimitMob) {
      } else {
        let next = i + 1;
        turnSlideMob(next);
        nameWrapMob.innerHTML = allNamesMob[next].innerHTML;
      }
    });
  });

});

//Functions
let turnSlideDesk = function (current) {
  allSlidesDesk.forEach(function (item, i) {
    if (current == i) {
      item.classList.remove("hide");
    } else {
      item.classList.add("hide");
    }
  });
};

let turnSlideMob = function (current) {
  let checkSS25 = document.querySelector("#shopify-section-lb-ss25-mobile");

  if(checkSS25 == null){ 
    allSlidesMob.forEach(function (item, i) {
      if (current == i) {
        item.classList.remove("hide");
      } else {
        item.classList.add("hide");
      }
    });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  resizeSite();
});

function resizeSite() {
  var windowHeight = window.innerHeight;

  var projects = document.querySelectorAll(".slide-block-mobile");

  for (var i = 0; i < projects.length; i++) {
    var project = projects[i];

    if (project.classList.contains("collapsed")) {
      // Do nothing if collapsed
    } else {
      project.style.height = windowHeight - 100 + "px";
    }
  }
}
